/**
 * 录像回放
 * @Author wuTao
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool } from '@/tool'
import { WizTableForm } from '@/containers/common';
import { modelUtils } from "@/utils";
import moment from "moment";

let { WizTable, WizSpin } = component_tool

const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}
let {
  WizContainer,
} = framework_tool;


class AuthVideo extends WizContainer {
  componentName = 'authVideo';

  constructor(props) {
    super(props);
    this.state = {
      value: []
    };
  }

  _componentDidMount() {
    const { record } = this.props;
    if (record.ownerId) {
      this.doAction({
        path: "interactLive/getInteractLiveRecordVideo",
        payload: {
          key: "getInteractLiveRecordVideo_"+record.ownerId,
          apiParams: {
            ownerId: record.ownerId
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    remoteAuthVideo: this._getDataOver.bind(this)
  };

  _getDataOver(nextProps, nextState) {
    if (nextProps.remoteAuthVideo.code === 1) {
      nextState.value = nextProps.remoteAuthVideo.data
    }
    return true
  }


  _render() {
    let { type, record, interactLiveLoading } = this.props;
    let columns = [
      {
        title: '录像名称',
        dataIndex: 'name',
        key: 'name',
        width: 50,
        render: (text, record, index) => (
          <a href={type == 1 ? record.downUrl : record.playUrl} target="_blank" style={{color: '#1890ff'}}>录像{index + 1}</a>
        ),
      },
      {
        title: '结束时间',
        dataIndex: 'endDate',
        key: 'endDate',
        width: 100,
        render: (text, record) => (
          <>{record.endDate}</>
        ),
      }
    ]
    return (
      <WizSpin tip={''} spinning={interactLiveLoading}>
        <WizTable pagination={false} columns={columns} dataSource={this.state.value} />
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let { record } = ownProps
  const { interactLive } = state;
  const remoteAuthVideo = modelUtils.getModelEntity(interactLive, "getInteractLiveRecordVideo_"+ownProps.record.ownerId);
  const load = modelUtils.getLoadingState(state, ['interactLive']);
  return {
    remoteAuthVideo,
    ...load
  }
};
const options = { withRef: true };
export default connect(mapStateToProps, null, null, options)(AuthVideo);
